import { Component } from '@angular/core';
import { CartCreationDialogBaseComponent } from 'projects/shared/lib/components/shared/cart/cart-creation-dialog/cart-creation-dialog-base.component';

@Component({
    selector: 'app-cart-creation-dialog',
    templateUrl: './cart-creation-dialog.component.html',
    standalone: false
})
export class CartCreationDialogComponent extends CartCreationDialogBaseComponent {}
